import { header } from '../components/header.js';
import { footer } from '../components/footer.js';
import { CartDrawer, NewsletterComponent, PriceComponent } from '../components/vndaComponents.js';

export const pages = {
  init: () => {        
    header.init();
    footer.init();

    NewsletterComponent.init()
    CartDrawer.init();
    // setCartDrawer()
    PriceComponent.init();
  },
};
